<template>
    <div>
        <section class="q10__jumbotron relative">
            <!-- {{getRichmediaByCollection(
                        currentPage,
                        'RIZZANESE EN CORSE'
                    )}} -->
            <hotspot-richmedia
                :options='{
                    icon: "diaporama",
                    collection:  [
                        {
                            "src": getSpecificURL() + "fr/richmedia/page-012/img42.jpg",
                            "type": "image",
                            "caption": "RIZZANESE EN CORSE",
                            
                        }
                    ] 
                }'
                class="bottom-6 left-12"
            />
            

            <image-with-descriptions
                class="mb-8 mt-0 md:-mt-12"
                :options="{
                    image:
                        'pages/' +
                        currentPage.slug +
                        '/' +
                        currentPage.images.imageJumbotron.src,
                    descriptions: [
                        {
                            text: currentPage.images.imageJumbotron.edf,
                            position: 'bottom-right', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        },
                    ],
                }"
            />
            
        </section>
        <div class="page">
            <div class="container px-11 2xl:px-3 lg:px-3 mb-14 m-auto">
                <title-s-chapter
                    :options="{
                        from: 'from-resolution_blue',
                        to: 'to-line',
                    }"
                >
                    <h1 v-html="currentPage.content.mainTitle.text"></h1>
                </title-s-chapter>
                <p
                    class="font-bold text-tundora text-xl mb-5"
                    v-html="currentPage.content.description.text"
                ></p>

                <div class="container-components">
                    <div class="card break-inside-avoid">
                        <TitleParagraph
                            :options="{
                                from: 'from-resolution_blue',
                                to: 'to-line',
                            }"
                        >
                            <p
                                class="text-xl lg:text-2xl 2xl:text-4xl"
                                v-html="currentPage.content.firstTitle.text"
                            ></p>
                        </TitleParagraph>
                        <TitleParagraph
                            :options="{
                                from: 'from-resolution_blue',
                                to: 'to-line',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                    direction: 'top',
                                }"
                            />
                            <span
                                v-html="currentPage.content.firstSubTitle.text"
                            ></span>
                        </TitleParagraph>
                    </div>

                    <div class="card break-inside-avoid">
                        <div>
                            <span class="timeline-title__content text-lg text-nandor"
                                v-html="currentPage.content.firstParagraph.text"
                            ></span>
                            <!-- <Dots
                                :options="{
                                    colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                }"
                            /> -->
                        </div>

                        <div class="relative">
                            <hotspot-richmedia
                                :options='{
                                    icon: "diaporama",
                                    collection:  [
                                        {
                                            "src": getSpecificURL() + "fr/richmedia/page-012/dev_28_29_retrospective_inauguration_romanche_gavet_9_octobre_2020.mp4",
                                            "type": "html5video",
                                            "caption": "Romanche Gavet - Epopée 2010-2020",
                                            "thumb": getSpecificURL() + "fr/images/thumbs/developpement_france_et_inter/resized_Retrospective_inauguration.png"
                                        },
                                        {
                                            "src": getSpecificURL() + "fr/richmedia/page-012/new_img48.jpg",
                                            "type": "image",
                                            "caption": "Photo d’équipe : Romanche Gavet en en Isère",
                                            
                                        },
                            
                                    ] 
                                }'
                                class="top-2 right-2"
                            />
                            <image-with-descriptions
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.image1.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.image1.edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>

                        <TitleParagraph
                            :options="{
                                from: 'from-resolution_blue',
                                to: 'to-line',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                    direction: 'top',
                                }"
                            />
                            <span
                                v-html="currentPage.content.secondSubTitle.text"
                            ></span>
                        </TitleParagraph>

                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span class="timeline-title__content  text-lg text-nandor"
                                v-html="
                                    currentPage.content.secondParagraph.text
                                "
                            >
                            </span>
                        </paragraph>
                    </div>

                    <div class="card break-inside-avoid">
                        <div class="relative">
                            <hotspot-richmedia
                                :options='{
                                    icon: "diaporama",
                                    collection:  [
                                    {
                                        "src": getSpecificURL() + "fr/richmedia/page-012/dev_29_2016_romanche_gavet_ouvrages_restitution_et_dissipateurs.mp4", //H",
                                        "type": "html5video",
                                        "caption": "Romanche Gavet - Ouvrages de restitution et dissipateurs - 2016",
                                        
                                    },
                                   
                                    ] 
                                }'
                                class="top-2 right-2"
                            />
                            <image-with-descriptions
                                class="eliminate-margin"
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.image2.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.image2.edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>

                        <p class="timeline-title__content text-lg " 
                        v-html="currentPage.content.thirdParagraph.text"></p>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span class="timeline-title__content text-lg text-nandor"
                                v-html="
                                    currentPage.content.fourthParagraph.text
                                "
                            ></span>
                            <!-- <Dots
                                :options="{
                                    colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                }"
                            /> -->
                        </paragraph>
                    </div>

                    <div class="card break-inside-avoid">
                        <div class="relative">
                            <hotspot-richmedia
                                :options='{
                                    icon: "diaporama",
                                    collection:  [
                                        {
                                            "src": getSpecificURL() + "fr/richmedia/page-012/dev_30_31_2013_romanche_gavet_excavation_des_cavernes.mp4",
                                            "type": "html5video",
                                            "caption": "Romanche Gavet - Excavation des cavernes - 2013",
                                            "thumb": getSpecificURL() + "fr/images/thumbs/developpement_france_et_inter/resized_excavation_traditionnelle.png"
                                        },
                                        {
                                            "src": getSpecificURL() + "fr/richmedia/page-012/dev_30_31_2016_romanche_gavet_24h_vie_du_tunnelier_3min.mp4",
                                            "type": "html5video",
                                            "caption": "Romanche Gavet - 24h vie du tunnelier - 2016",
                                            "thumb": getSpecificURL() + "fr/images/thumbs/developpement_france_et_inter/4.7_Romanche_Gavet_24h_vie_du_tunnelier_2016.jpg"
                                        },
                                    ] 
                                }'
                                class="top-2 right-2"
                            />

                            <div>
                                <image-with-descriptions
                                    :options="{
                                        image:
                                            'pages/' +
                                            currentPage.slug +
                                            '/' +
                                            currentPage.images.image3.src,
                                        descriptions: [
                                            {
                                                text: currentPage.images.image3
                                                    .edf,
                                                position: 'bottom-right', // top/bottom-left/right
                                                orientation: 'horizontal', // vertical, horizontal
                                            },
                                        ],
                                    }"
                                />
                            </div>

                            <TitleParagraph
                                :options="{
                                    from: 'from-resolution_blue',
                                    to: 'to-line',
                                }"
                            >
                                <Triangles
                                    :options="{
                                        colors: [
                                            '#00357f',
                                            '#0b4f9c',
                                            '#0d94ff',
                                        ],
                                        direction: 'top',
                                    }"
                                />
                                <span
                                    v-html="
                                        currentPage.content.thirdSubTitle.text
                                    "
                                ></span>
                            </TitleParagraph>
                        </div>
                        
                    </div>
                    <paragraph
                        :options="{
                            color: 'text-nandor',
                        }"
                    >
                        <span class="timeline-title__content text-lg text-nandor" 
                        v-html="currentPage.content.fifthParagraph.text">
                        </span>
                        <!-- <Dots
                            :options="{
                                colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                            }"
                        /> -->
                    </paragraph>
                    </div>
                
                <!-- AICI -->
                <div class="relative">
                    <!-- <hotspot-richmedia
                        :options="{
                            icon: 'diaporama',
                            collection: getRichmediaByCollection(
                                currentPage,
                                'Romanche Gavet, 10 ans de travaux titanesques  '
                            ),
                        }"
                        class="top-2 right-2"
                    /> -->
                    <div
                        class="
                            container-timeline-title-si-image-with-description-second-2
                            card
                            relative
                            mt-8
                        "
                    >
                        <div class="relative w-full h-full">
                            <image-with-descriptions
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.image4.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.image4.edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                        <div class="q10__textInImage_1">
                            <h2
                                class="q10__title"
                                v-html="currentPage.content.secondTitle.text"
                            ></h2>
                        </div>
                        <div class="q10__textInImage_2">
                            <p
                                class="q10__paragraph text-lg" 
                                v-html="currentPage.content.sixthParagraph.text"
                            ></p>
                        </div>
                    </div>
                </div>

                <div class="card">
                    <TitleParagraph
                        :options="{
                            from: 'from-resolution_blue',
                            to: 'to-line',
                        }"
                    >
                        <p
                            class="text-xl lg:text-2xl 2xl:text-4xl"
                            v-html="currentPage.content.thirdTitle.text"
                        ></p>
                    </TitleParagraph>
                    <div class="container-components">
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="currentPage.content.eigthParagraph.text"
                            >
                            </span>
                        </paragraph>
                    </div>
                </div>

                <div class="relative">
                    <hotspot-richmedia
                        :options='{
                                    icon: "diaporama",
                                    collection:  [
                                        {
                                            "src": getSpecificURL() + "fr/richmedia/page-012/dev_32_35_nam_theun_presentation.mp4",
                                            "type": "html5video",
                                            "caption": "Nam Theun 2 : présentation du projet",
                                            "thumb": getSpecificURL() + "fr/images/thumbs/developpement_france_et_inter/Nam_Theun_Mise.png", 
                                        },
                                        {
                                            "src": getSpecificURL() + "fr/richmedia/page-012/dev_32_35_nam_theun_en_images.mp4",
                                            "type": "html5video",
                                            "caption": "Nam Theun 2 : mise en service de l’aménagement en 2009",
                                            "thumb": getSpecificURL() + "fr/images/thumbs/developpement_france_et_inter/NT-MiseEnService.jpg"
                                        },
                                        {
                                            "src": getSpecificURL() + "fr/richmedia/page-012/dev_32_35_nam_theun_leau_du_reservoir.mp4",
                                            "type": "html5video",
                                            "caption": "Nam Theun 2 : le réservoir",
                                            "thumb": getSpecificURL() + "fr/images/thumbs/developpement_france_et_inter/IntroPhoto_NT_reservoir.jpg"
                                        },
                                        {
                                            "src": getSpecificURL() + "fr/richmedia/page-012/diapositive_intro.png",
                                            "type": "image",
                                            "caption": "Nam Theun 2 : Album photos",
                                        },
                                        {
                                            "src": getSpecificURL() + "fr/richmedia/page-012/diapositive1.jpg",
                                            "type": "image",
                                            "caption": "Nam Theun 2 : Album photos",
                                        },
                                        {
                                            "src": getSpecificURL() + "fr/richmedia/page-012/diapositive2.jpeg",
                                            "type": "image",
                                            "caption": "Nam Theun 2 : Album photos",
                                        },
                                        {
                                            "src": getSpecificURL() + "fr/richmedia/page-012/diapositive3.jpeg",
                                            "type": "image",
                                            "caption": "Nam Theun 2 : Album photos",
                                        },
                                        {
                                            "src": getSpecificURL() + "fr/richmedia/page-012/diapositive4.jpeg",
                                            "type": "image",
                                            "caption": "Nam Theun 2 : Album photos",
                                        },
                                        {
                                            "src": getSpecificURL() + "fr/richmedia/page-012/diapositive5.jpeg",
                                            "type": "image",
                                            "caption": "Nam Theun 2 : Album photos",
                                        },
                                        {
                                            "src": getSpecificURL() + "fr/richmedia/page-012/diapositive6.jpeg",
                                            "type": "image",
                                            "caption": "Nam Theun 2 : Album photos",
                                        },
                                        {
                                            "src": getSpecificURL() + "fr/richmedia/page-012/diapositive7.jpeg",
                                            "type": "image",
                                            "caption": "Nam Theun 2 : Album photos",
                                        },
                                        {
                                            "src": getSpecificURL() + "fr/richmedia/page-012/diapositive8.jpeg",
                                            "type": "image",
                                            "caption": "Nam Theun 2 : Album photos",
                                        },
                                        
                                        {
                                            "src": getSpecificURL() + "fr/richmedia/page-012/diapositive10.jpeg",
                                            "type": "image",
                                            "caption": "Nam Theun 2 : Album photos",
                                        },
                                        {
                                            "src": getSpecificURL() + "fr/richmedia/page-012/diapositive11.jpeg",
                                            "type": "image",
                                            "caption": "Nam Theun 2 : Album photos",
                                        },
                                        {
                                            "src": getSpecificURL() + "fr/richmedia/page-012/diapositive12.jpeg",
                                            "type": "image",
                                            "caption": "Nam Theun 2 : Album photos",
                                        },
                                        {
                                            "src": getSpecificURL() + "fr/richmedia/page-012/diapositive13.jpeg",
                                            "type": "image",
                                            "caption": "Nam Theun 2 : Album photos",
                                        },
                                        {
                                            "src": getSpecificURL() + "fr/richmedia/page-012/diapositive14.jpeg",
                                            "type": "image",
                                            "caption": "Nam Theun 2 : Album photos",
                                        },
                                        {
                                            "src": getSpecificURL() + "fr/richmedia/page-012/diapositive15.jpeg",
                                            "type": "image",
                                            "caption": "Nam Theun 2 : Album photos",
                                        },
                                    ] 
                                }'
                        class="top-2 right-2"
                    />

                    <image-with-descriptions
                        :options="{
                            image:
                                'pages/' +
                                currentPage.slug +
                                '/' +
                                currentPage.images.image5.src,
                            descriptions: [
                                {
                                    text: currentPage.images.image5.edf,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                },
                            ],
                        }"
                    />
                </div>
               
                    <div class="container-components">
                    <!-- <div class="card"> -->
                        <TitleParagraph
                            :options="{
                                from: 'from-resolution_blue',
                                to: 'to-line',
                            }"
                        >
                        <Triangles
                            :options="{
                                colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                direction: 'top',
                            }"
                        />
                        <span
                            class="text-xl text-bold"
                            v-html="currentPage.content.fourthSubTitle.text"
                        ></span>
                        </TitleParagraph>
                        <!-- <div class="container-components"> -->
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.seventhParagraph
                                        .text
                                "
                            ></span>
                            <!-- <Dots
                                :options="{
                                    colors: [
                                        '#00357f',
                                        '#0b4f9c',
                                        '#0d94ff',
                                    ],
                                }"
                            /> -->
                        </paragraph>
                        <!-- </div> -->
                   

                    <!-- <div class="relative"> -->
                        <!-- <hotspot-richmedia
                            :options="{
                                icon: 'diaporama',
                                collection: getRichmediaByCollection(
                                    currentPage,
                                    'Nam Theun 2, le rêve du XXe siècle devenu réalité au XXIe'
                                ),
                            }"
                            class="top-2 right-2 lg:right-32"
                        /> -->
                        <div class="lg:w-1/2 lg:mx-auto">
                            <image-with-descriptions
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.image6.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.image6.edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                    <!-- </div> -->
                    <!-- </div> -->
               
                    <div class="card">
                       
                            <paragraph
                                :options="{
                                    color: 'text-nandor',
                                }"
                            >
                                <!-- <Dots
                                    :options="{
                                        colors: [
                                            '#00357f',
                                            '#0b4f9c',
                                            '#0d94ff',
                                        ],
                                    }"
                                /> -->
                                <span
                                    v-html="
                                        currentPage.content.ninthParagraph.text
                                    "
                                >
                                </span>
                                <Triangles
                                    :options="{
                                        colors: [
                                            '#00357f',
                                            '#0b4f9c',
                                            '#0d94ff',
                                        ],
                                        direction: 'bottom',
                                    }"
                                />
                            </paragraph>
                        </div>
                    </div>
                
                <div class="relative">
                    <hotspot-richmedia
                        :options='{
                    icon: "diaporama",
                    collection:  [
                        {
                            "src": getSpecificURL() + "fr/richmedia/page-012/nam_theun_pv_flottant.mp4",
                            "type": "html5video",
                            "caption": "Nam Theun PV Flottant",
                            "thumb": getSpecificURL() + "fr/images/thumbs/developpement_france_et_inter/Nam_Theun_PV_Flottant.png"
                        }
                    ] 
                }'

                        class="top-2 right-2"
                    />
                    <image-with-descriptions
                        :options="{
                            image:
                                'pages/' +
                                currentPage.slug +
                                '/' +
                                currentPage.images.image7.src,
                            descriptions: [
                                {
                                    text: currentPage.images.image7.edf,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                },
                                {
                                    text: currentPage.images.image7.alt,
                                    position: 'top-left', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                },
                            ],
                        }"
                    />
                </div>

                <div class="relative">
                    <hotspot-richmedia
                        :options='{
                    icon: "diaporama",
                    collection:  [
                        {
                            "src": getSpecificURL() + "fr/richmedia/page-012/dev_32_35_nam_theun_la_gestion_de_leau_linternational.mp4",
                            "type": "html5video",
                            "caption": "Nam Theun 2 : la gestion de l’eau",
                            "thumb": getSpecificURL() + "fr/images/thumbs/developpement_france_et_inter/NT-Gestion.jpg"
                                }
                            ] 
                        }'
                                class="top-2 right-2"
                            />

                    <div class="relative w-full h-full my-5 bg-black overflow-hidden">
                        <image-with-descriptions class="opacity-100 lg:opacity-80 object-cover" style="margin: 0;"
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.image8.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.image8.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                    </div>
                    <div class="q10__textInImage_3">
                        <h2
                            class="q10__title"
                            v-html="currentPage.content.fourthTitle.text"
                        ></h2>
                        <p
                            class="q10__paragraph"
                            v-html="currentPage.content.tenParagraph.text"
                        ></p>
                    </div>
                </div>

                <div class="container-components">
                    <div class="relative">
                        <hotspot-richmedia
                            :options="{
                                icon: 'diaporama',
                                collection: getRichmediaByCollection(
                                    currentPage,
                                    'Cameroun : projet Nachtigal'
                                ),
                            }"
                            class="top-2 right-2"
                        />
                        <image-with-descriptions
                            style="margin: 0; margin-bottom: 1.25rem"
                            class="relative"
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.image9.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.image9.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                    </div>

                    <div class="card break-inside-avoid">
                        <TitleParagraph
                            :options="{
                                from: 'from-resolution_blue',
                                to: 'to-line',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                    direction: 'top',
                                }"
                            />
                            <span
                                class="text-xl text-bold"
                                v-html="currentPage.content.fifthSubTitle.text"
                            ></span>
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="currentPage.content.eleventhParagraph.text"
                            >
                            </span>
                            <Triangles
                                :options="{
                                    colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                    direction: 'bottom',
                                }"
                            />
                        </paragraph>

                        <div class="relative">
                            <!-- <hotspot-richmedia
                                :options="{
                                    icon: 'diaporama',
                                    collection: getRichmediaByCollection(
                                        currentPage,
                                        'Cameroun : projet Nachtigal'
                                    ),
                                }"
                                class="top-2 right-2"
                            /> -->
                            <image-with-descriptions
                                class="relative"
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.image10.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.image10.edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                    </div>

                    

                    <div class="card break-inside-avoid" style="padding-top: 0">
                         <image-with-descriptions
                            class="relative eliminate-margin"
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.image11.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.image11.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                    {
                                        text: currentPage.images.image11.alt,
                                        position: 'top-left', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                        <TitleParagraph
                            :options="{
                                from: 'from-resolution_blue',
                                to: 'to-line',
                            }"
                        >
                            <span
                                class="text-xl text-bold"
                                v-html="currentPage.content.sixthSubTitle.text"
                            ></span>
                            <Triangles
                                :options="{
                                    colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                    direction: 'top',
                                }"
                            />
                        </TitleParagraph>
                        <div class="container-components">
                            <paragraph
                                :options="{
                                    color: 'text-nandor',
                                }"
                            >
                                <span
                                    v-html="
                                        currentPage.content.twelveParagraph.text
                                    "
                                >
                                </span>
                            </paragraph>
                        </div>
                       
                    </div>

                    <div class="card" style="padding-top: 0">
                        <TitleParagraph
                            :options="{
                                from: 'from-resolution_blue',
                                to: 'to-line',
                            }"
                        >
                            <span
                                class="text-xl text-bold"
                                v-html="
                                    currentPage.content.seventhSubTitle.text
                                "
                            ></span>
                        </TitleParagraph>
                        <div class="container-components">
                            <paragraph
                                :options="{
                                    color: 'text-nandor',
                                }"
                            >
                                <span
                                    v-html="
                                        currentPage.content.thirdteenParagraph
                                            .text
                                    "
                                >
                                </span>
                                <!-- <square
                                    :options="{
                                        from: 'from-resolution_blue',
                                        to: 'to-line',
                                    }"
                                /> -->
                            </paragraph>
                        </div>
                    </div>
                    <div class="card" style="padding-top: 0">
                        <article-note
                            class="eliminate-margin"
                            :options="{
                                verticalcontent:
                                    currentPage.content.verticalText.text,
                                content:
                                    currentPage.content.authorDescription.text,

                                color: {
                                    verticalcontent: 'text-cornflower_blue',
                                    content: 'text-nandor',
                                },
                                fontSize: {
                                    verticalcontent: 'text-4xl lg:text-2xl',
                                    content: '',
                                },

                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.image12.src,

                                descriptions: [
                                    {
                                        text: currentPage.images.image12.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";
import TitleSChapter from "../../components/TitleSChapter.vue";
import Triangles from "../../components/Triangles.vue";
import TitleParagraph from "../../components/TitleParagraph.vue";
import Paragraph from "../../components/Paragraph.vue";
import ImageWithDescriptions from "../../components/ImageWithDescriptions.vue";

export default {
    components: {
        TitleSChapter,
        Triangles,
        TitleParagraph,
        ImageWithDescriptions,
        Paragraph,
    },
    name: "PageTest",
    mixins: [PagesMixin],
};
</script>

<style scoped lang="scss">
.q10__textInImage_1 {
    position: absolute;
    top: 5vh;
    left: 0;
    padding: 3rem;
    width: 100%;
    column-count: 1;

    @media (max-width: 1536px) {
        top: 7vh;
        padding: 3rem;
    }
    @media (max-width: 768px) {
        padding: 0;
        position: relative;
        column-count: unset;
        margin-top: 1rem;
        padding: 0;
    }

    .q10__title {
        position: absolute;
        width: 100%;
        top: 0;
        padding: 0;
        font-size: 3rem;
        color: white;
        text-align: start;
        line-height: 1;
        font-weight: bold;
        @media (max-width: 1536px) {
            top: -6vh;
            padding: 3rem;
            left: 0;
        }
        @media (max-width: 1024px) {
            font-size: 2.5rem;
        }
        @media (max-width: 768px) {
            position: relative;
            font-size: 1.5rem;
            padding: 0;
            left: 0;
            @apply text-nandor;
        }
    }
}
.q10__textInImage_2 {
    position: absolute;
    top: 10vh;
    column-count: 3;
    padding: 3rem;
    column-gap: 40px;
    @media (max-width: 1536px) {
        top: 12vh;
        padding: 3rem;
    }
    @media (max-width: 768px) {
        top: 0;
        padding: 0;
        position: relative;
        column-count: unset;
        margin-top: 1rem;
    }
    .q10__paragraph {
        position: relative;
        top: 0vh;
        height: 100px;
        color: white;
        @media (max-width: 1024px) {
            font-size: 0.75rem;
        }
        @media (max-width: 768px) {
            @apply text-nandor;
            font-size: 1rem;
            position: relative;
            height: 100%;
            margin-bottom: 2rem;
        }
    }
}

.q10__textInImage_3 {
    @apply text-white;
    position: absolute;
    bottom: 5%;
    left: 0;
    padding: 0 3rem;
    width: 100%;

    @media (max-width: 1023px) {
        padding: 0;
        position: relative;
        column-count: unset;
        margin: 1rem 0 0 0;
    }
    .q10__title {
        height: 100%;
        width: 100%;
        padding: 0;
        font-size: 3rem;
        margin-bottom: 1rem;
        line-height: 1;
        font-weight: bold;
        @media (max-width: 1023px) {
            font-size: 2.5rem;
            position: relative;
            @apply text-nandor;
            padding: 0;
            left: 0;
        }
        @media (max-width: 768px) {
            font-size: 1.5rem;
            
        }
    }
    .q10__paragraph {
        column-count: 3;
        column-gap: 40px;
        @media (max-width: 1023px) {
            font-size: 0.8rem;
            position: relative;
            height: 100%;
            margin-bottom: 2rem;
            column-count: unset;
            @apply text-nandor;
        }
        @media (max-width: 1023px) {
            font-size: 1rem;
        }
    }
}
// .q10__textInImage_4 {
//     position: absolute;
//     @apply text-white;
//     bottom: 0;
//     column-count: 3;
//     padding: 3rem;
//     @media (max-width: 1536px) {
//         top: 12vh;
//     }
//     @media (max-width: 1280px) {
//         top: 5vh;
//         font-size: 0.9rem;
//     }
//     @media (max-width: 1024px) {
//         top: 2vh;
//     }
//     @media (max-width: 768px) {
//         padding: 0;
//         position: relative;
//         column-count: unset;
//         height: 100%;
//         margin-bottom: 3.5rem;
//         @apply text-nandor;
//     }
//     .q10__paragraph {
//         position: relative;
//         top: 0vh;
//         height: 100px;
//         @apply text-white;
//         @media (max-width: 1024px) {
//             font-size: 0.6rem;
//         }
//         @media (max-width: 768px) {
//             font-size: 1rem;
//             @apply text-nandor;
//             height: 100%;
//         }
//     }
// }

.timeline {
    column-width: 380px;
    column-gap: 40px;
    position: relative;
    margin: 5px 0;
    padding: 0;
    display: inline-block;
    width: 100%;
    height: auto;
}

.card {
    margin: 0;
}
</style>
